<template>
  <!-- Rich content blocks -->
  <div v-if="hasRichContent" class="lesson-renderer">
    <template v-for="(block, index) in richContent" :key="index">
      <HeadingBlock v-if="block.type === 'heading'" :block="block" />
      <ParagraphBlock v-else-if="block.type === 'paragraph'" :block="block" />
      <CalloutBlock v-else-if="block.type === 'callout'" :block="block" />
      <ToggleBlock v-else-if="block.type === 'toggle'" :block="block" />
      <KeyPointsBlock v-else-if="block.type === 'key_points'" :block="block" />
      <InlineQuizBlock v-else-if="block.type === 'inline_quiz'" :block="block" />
      <ImageBlock v-else-if="block.type === 'image'" :block="block" />
      <ListBlock v-else-if="block.type === 'list'" :block="block" />
      <QuoteBlock v-else-if="block.type === 'quote'" :block="block" />
      <CodeBlock v-else-if="block.type === 'code'" :block="block" />
      <hr v-else-if="block.type === 'divider'" class="lesson-divider" />
    </template>
  </div>

  <!-- Markdown fallback for textContent -->
  <div v-else-if="textContent" class="lesson-renderer">
    <ParagraphBlock :block="{ type: 'paragraph', markdown: textContent }" />
  </div>

  <!-- Empty state -->
  <div v-else class="lesson-empty">
    <q-icon name="auto_stories" size="48px" :style="{ color: 'var(--oa-text-muted)', opacity: 0.5 }" />
    <p>Contenido en preparacion.</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import HeadingBlock from './blocks/HeadingBlock.vue';
import ParagraphBlock from './blocks/ParagraphBlock.vue';
import CalloutBlock from './blocks/CalloutBlock.vue';
import ToggleBlock from './blocks/ToggleBlock.vue';
import KeyPointsBlock from './blocks/KeyPointsBlock.vue';
import InlineQuizBlock from './blocks/InlineQuizBlock.vue';
import ImageBlock from './blocks/ImageBlock.vue';
import ListBlock from './blocks/ListBlock.vue';
import QuoteBlock from './blocks/QuoteBlock.vue';
import CodeBlock from './blocks/CodeBlock.vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ContentBlock = Record<string, any>;

const props = defineProps<{
  richContent: ContentBlock[] | null;
  textContent: string | null;
}>();

const hasRichContent = computed(() => {
  return props.richContent && props.richContent.length > 0;
});
</script>

<style scoped lang="scss">
.lesson-renderer {
  padding: 28px 20px 32px;

  @media (min-width: 768px) {
    padding: 36px 36px 44px;
  }

  @media (min-width: 1024px) {
    padding: 44px 56px 56px;
  }
}

.lesson-empty {
  padding: 80px 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  p {
    color: var(--oa-text-muted);
    margin: 0;
    font-size: var(--oa-text-sm);
  }
}

.lesson-divider {
  border: none;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    color-mix(in srgb, var(--oa-gold-full) 35%, transparent) 50%,
    transparent 100%
  );
  margin: 32px 0;
}
</style>
